import { FETCH_LISTING_APPLICATIONS_FAILURE, FETCH_LISTING_APPLICATIONS_SUCCESS } from '../constants/actionTypes';
import { INIT_LISTING_APPLICATIONS_TAB_ERROR } from '../constants/messages';
import { isBrownoutOn } from '../utils/brownoutUtil';

import {
  fetchIsOnboardingPageViewed,
  updateBackendIsOnboardingPageViewed,
  updateIsOnboardingPageViewed,
} from '../actions/onboardingActionCreators';
import { markRentalTermsAccepted } from '../actions/rentalTermsActionCreators';
import { listingApplicationsTabLoadingStatusUpdate } from '../actions/loadingStatusActionCreators';
import { logError } from '@zg-rentals/log-error';

function fetchListingApplicationsDataSuccess(payload) {
  return { type: FETCH_LISTING_APPLICATIONS_SUCCESS, payload };
}

function fetchListingApplicationsDataFailure(payload) {
  return { type: FETCH_LISTING_APPLICATIONS_FAILURE, payload };
}

function refreshListingApplicationsTabData() {
  return (dispatch, getState) => {
    const { user = {} } = getState();
    const { applicationsEnabled = false } = user;

    // The user.applicationsEnabled value is controlled by ZRM. As long as user has ever enabled accept applications on
    // any listing, this will be true. We rely on this flag to make sure we don't show onboarding page.
    if (applicationsEnabled) {
      dispatch(updateIsOnboardingPageViewed({ isOnboardingPageViewed: true }));
    }

    dispatch(fetchIsOnboardingPageViewed()).then(() => {
      const { rentalApplication = {} } = getState();
      const { landlord = {} } = rentalApplication;
      const { isOnboardingPageViewed } = landlord;

      if (!isOnboardingPageViewed && applicationsEnabled) {
        dispatch(updateBackendIsOnboardingPageViewed());
        dispatch(markRentalTermsAccepted());
      }
    }, null);
  };
}

function hideOnboarding(dispatch) {
  dispatch(updateBackendIsOnboardingPageViewed());
  dispatch(updateIsOnboardingPageViewed({ isOnboardingPageViewed: true }));
  dispatch(markRentalTermsAccepted());
}

function initListingApplicationsTabData() {
  return (dispatch, getState) => {
    dispatch(
      listingApplicationsTabLoadingStatusUpdate({
        showSpinner: true,
        show: true,
      }),
    );

    dispatch(fetchIsOnboardingPageViewed()).then(
      () => {
        try {
          const { rentalApplication = {}, user = {} } = getState();
          const { landlord = {} } = rentalApplication;
          const { isOnboardingPageViewed } = landlord;
          const { applicationsEnabled = false } = user;

          if (!isOnboardingPageViewed && applicationsEnabled) {
            hideOnboarding(dispatch);
          }

          dispatch(
            listingApplicationsTabLoadingStatusUpdate({
              show: false,
              showSpinner: false,
            }),
          );
          dispatch(fetchListingApplicationsDataSuccess());
        } catch (error) {
          logError({ context: 'listingApplicationsTabLoadingStatusUpdate', error });
          dispatch(fetchListingApplicationsDataFailure());
          dispatch(
            listingApplicationsTabLoadingStatusUpdate({
              message: INIT_LISTING_APPLICATIONS_TAB_ERROR,
              isError: true,
              showSpinner: false,
              show: true,
            }),
          );
        }
      },
      (serverError) => {
        if (isBrownoutOn(serverError)) {
          return;
        }
        dispatch(fetchListingApplicationsDataFailure());
        dispatch(
          listingApplicationsTabLoadingStatusUpdate({
            message: INIT_LISTING_APPLICATIONS_TAB_ERROR,
            isError: true,
            showSpinner: false,
            show: true,
          }),
        );
      },
    );
  };
}

const loadListingApplicationsTabData = (payload) => (dispatch, getState) => {
  const { rentalApplication = {} } = getState();
  const { loadingStatus = {} } = rentalApplication;
  const { initRequestStatus = {} } = loadingStatus;

  if (initRequestStatus.listingApplicationsLoaded) {
    dispatch(refreshListingApplicationsTabData(payload));
  } else {
    dispatch(initListingApplicationsTabData(payload));
  }
};

export { loadListingApplicationsTabData, hideOnboarding };
